import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable, from, switchMap } from 'rxjs';
import { environment } from '@environments/environment';

import { FirebaseAuthClientService } from '../services/firebase/firebase-auth-client.service';

@Injectable()
export class QueryApiAuthInterceptor implements HttpInterceptor {
  private readonly queryApiBaseUrl = this.normalizeUrl(environment.baseUrl || '');
  private firebaseAuth: FirebaseAuthClientService | null = null;

  constructor(private readonly injector: Injector) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (!this.shouldAttachToken(req.url)) {
      return next.handle(req);
    }

    if (!this.firebaseAuth) {
      this.firebaseAuth = this.injector.get(FirebaseAuthClientService);
    }

    return from(this.firebaseAuth.getCurrentIdTokenWhenReady()).pipe(
      switchMap((idToken) => {
        if (!idToken) {
          return next.handle(req);
        }

        const authorizedRequest = req.clone({
          setHeaders: {
            Authorization: `Bearer ${idToken}`
          }
        });

        return next.handle(authorizedRequest);
      })
    );
  }

  private shouldAttachToken(url: string): boolean {
    if (environment.authProvider !== 'firebase') {
      return false;
    }

    if (!this.queryApiBaseUrl) {
      return false;
    }

    return this.normalizeUrl(url).startsWith(this.queryApiBaseUrl);
  }

  private normalizeUrl(url: string): string {
    return (url || '').replace(/\/+$/, '');
  }
}
